import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import {
    piIconBlackhatLaptopBold,
    piIconComputerGuideBold,
    piIconPendo,
    piIconPlaygroundBold,
    piIconTranslateBold
} from '@predictiveindex/pi-client-icons';
import {
    TapestryDropdownModule,
    TapestryIconButtonModule,
    TapestryIconRegistryService
} from '@predictiveindex/tapestry';
import { DeveloperDropdownComponent } from './developer-dropdown.component';

@NgModule({
    declarations: [DeveloperDropdownComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        TapestryDropdownModule,
        TapestryIconButtonModule
    ],
    exports: [DeveloperDropdownComponent]
})
export class DeveloperDropdownModule {
    constructor(iconRegistry: TapestryIconRegistryService) {
        iconRegistry.registerIcons([
            piIconBlackhatLaptopBold,
            piIconComputerGuideBold,
            piIconPendo,
            piIconPlaygroundBold,
            piIconTranslateBold
        ]);
    }
}
